import React from "react"
import firebase from "gatsby-plugin-firebase"
import { Stream } from "@cloudflare/stream-react"
import { Dialog } from "@headlessui/react"
import style from "./video.module.scss"
import { trackCustomEvent } from "gatsby-plugin-google-analytics"


// import createPersistedState from "use-persisted-state"

const Video = props => {
  const [init, setInit] = React.useState(false)
  const [login, setLogin] = React.useState(null)
  const [loginProcess, setLoginProcess] = React.useState(false)
  const [verifying, setVerifying] = React.useState(false)
  const [verifyProcess, setVerifyProcess] = React.useState(false)
  const [purchased, setPurchased] = React.useState(true)
  const [isOpen, setIsOpen] = React.useState(false)
  const [message, setMessage] = React.useState("")
  // const [invoiceType, setInvoiceType] = React.useState(2)
  // const [purchaseProcess, setPurchaseProcess] = React.useState(false)
  // const [formInput, setFormInput] = React.useState([])
  const [stream, setStream] = React.useState(null)
  const [loading, setLoading] = React.useState(true)
  const [qa, setQA] = React.useState(true)

  const phoneRef = React.useRef(null)
  const verifyRef = React.useRef(null)
  const handleLogin = () => {
    setLoginProcess(true)
    if (!phoneRef.current.value) {
      setMessage("請輸入手機號碼")
      setIsOpen(true)
      setLoginProcess(false)
    } else {
      let phoneNumber = phoneRef.current.value
      if (phoneNumber.match("^[0-9]{10}$")) {
        phoneNumber = "+886" + phoneNumber.substr(1)
      }
      firebase.auth().languageCode = "zh-TW"
      firebase
        .auth()
        .setPersistence(firebase.auth.Auth.Persistence.SESSION)
        .then(() => {
          return firebase
            .auth()
            .signInWithPhoneNumber(phoneNumber, window.recaptchaVerifier)
            .then(confirmationResult => {
              window.confirmationResult = confirmationResult
              setVerifying(true)
              setLoginProcess(false)
              setMessage("")
            })
            .catch(error => {
              console.log(error)
              window.grecaptcha.reset(window.recaptchaWidgetId)
              if (error.code === "auth/invalid-phone-number") {
                setMessage("手機號碼格式錯誤")
              } else if (error.code === "auth/too-many-requests") {
                setMessage("驗證太頻繁，請過30分鐘後再試")
              } else {
                setMessage(error.code)
              }
              setIsOpen(true)
              setLoginProcess(false)
            })
        })
        .catch(error => {
          console.log(error)
          setMessage("遇到一點障礙，無法登入")
          setIsOpen(true)
          setLoginProcess(false)
        })
    }
  }

  const handleVerify = () => {
    setVerifyProcess(true)
    window.confirmationResult
      .confirm(verifyRef.current.value)
      .then(result => {
        setLogin(true)
        setVerifyProcess(false)
        setMessage("")
      })
      .catch(error => {
        setVerifyProcess(false)
        setMessage("驗證碼錯誤，重新輸入一次。")
      })
  }

  React.useEffect(() => {
    if (!init) {
      setInit(true)
      firebase.auth().languageCode = "zh-TW"
      try {
        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
          document.getElementById("recapacha"),
          {
            size: "invisible",
          }
        )
      } catch (ex) {
      } finally {
      }

      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          setLogin(true)

          const userData = firebase
            .firestore()
            .collection("users")
            .doc(user.phoneNumber)
          userData
            .get()
            .then(doc => {
              if (doc.exists) {
                setPurchased(true)
                setQA(doc.data().qa)

                const functions = firebase.app().functions("asia-northeast2")
                const getStream = functions.httpsCallable("getStream")
                getStream({ videoid: props.stream })
                  .then(value => {
                    setStream(value.data.videoIdOrSignedUrl)
                  })
                  .catch(error => {})
              } else {
                setPurchased(false)
              }
            })
            .catch(reason => {})
        } else {
          setLogin(false)
        }
      })
    }
  }, [init, login, message, props.stream])

  return (
    <>
      {init && login === false && !verifying && (
        <div>
          <div
            style={{
              color: "#fff",
              margin: "0 auto",
              padding: "0 1rem",
              textAlign: "justify",
              maxWidth: "720px",
              width: "100%",
              boxSizing: "border-box",
            }}
          >
            <h3>{props.writing.video_user_login_title}</h3>
            <div>{props.writing.video_user_login_description_taiwan}</div>
            <div style={{ fontSize: "0.75em" }}>
              {props.writing.video_user_login_description_international}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                margin: "0.5rem 0",
              }}
            >
              <input
                disabled={loginProcess}
                style={{
                  height: 40,
                  marginRight: 10,
                  padding: "0 10px",
                  display: "block",
                  width: 180,
                }}
                placeholder="請輸入手機號碼"
                ref={phoneRef}
                type="text"
                onKeyDown={e => {
                  if (e.key === "Enter") {
                    handleLogin()
                  }
                }}
              ></input>
              <button
                style={{ maxWidth: 100 }}
                disabled={loginProcess}
                onClick={handleLogin}
              >
                登入
              </button>
            </div>
            <a
              style={{
                margin: "0.5rem 0 1rem",
                display: "inline-block",
                color: "#fff",
                textDecoration: "underline",
                cursor: "pointer",
                float: "right",
              }}
              target="_blank"
              rel="noreferrer"
              href="https://tickets.ixda.org.tw/events/27"
            >
              還不是與會者嗎? 購買票券
            </a>
          </div>
        </div>
      )}
      {init && !login && verifying && (
        <div>
          <div
            style={{
              color: "#fff",
              margin: "0 auto",
              padding: "0 1rem",
              textAlign: "justify",
              maxWidth: "720px",
              width: "100%",
              boxSizing: "border-box",
            }}
          >
            <h3>{props.writing.video_user_verify_title}</h3>
            <div>{props.writing.video_user_verify_description}</div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                margin: "0.5rem 0",
              }}
            >
              <input
                disabled={verifyProcess}
                style={{
                  height: 40,
                  marginRight: 10,
                  padding: "0 10px",
                  display: "block",
                  width: 180,
                }}
                placeholder="請輸入簡訊中的驗證碼"
                ref={verifyRef}
                type="text"
                onKeyDown={e => {
                  if (e.key === "Enter") {
                    handleVerify()
                  }
                }}
              ></input>
              <button
                disabled={verifyProcess}
                onClick={handleVerify}
                style={{ maxWidth: 100 }}
              >
                驗證
              </button>
            </div>
            <div>
              <a
                style={{
                  margin: "0.5rem 0 1rem",
                  display: "inline-block",
                  color: "#fff",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  setVerifying(false)
                }}
                href="#"
              >
                {props.writing.video_user_verify_retry}
              </a>
            </div>
          </div>
        </div>
      )}
      {init && login && !purchased && (
        <div>
          <div
            style={{
              color: "#fff",
              margin: "0 auto",
              padding: "0 1rem",
              textAlign: "justify",
              maxWidth: "720px",
              width: "100%",
              boxSizing: "border-box",
            }}
          >
            <h3>身份驗證</h3>
            <div>
              很抱歉，看起來你目前沒有購買 IxDTW 2.0 互動設計年會 票券。
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                margin: "0.5rem 0 3rem",
              }}
            >
              <a
                class="cta"
                target="_blank"
                rel="noreferrer"
                href="https://tickets.ixda.org.tw/events/27"
              >
                馬上購買
              </a>
            </div>
          </div>
        </div>
      )}
      {init && login && purchased && !props.qa && (
        <div style={{ paddingTop: "56.25%", position: "relative" }}>
          <div
            style={{
              position: "absolute",
              inset: 0,
              height: "100%",
              width: "100%",
              top: 0,
            }}
          >
            <div
              className={style.loader}
              style={{ display: loading ? "block" : "none" }}
            >
              <div className={style.shadow}></div>
              <div className={style.box}></div>
            </div>
            {stream && (
              <Stream
                onCanPlay={() => {
                  setLoading(false)
                  trackCustomEvent({
                    category: "video",
                    action: "play",
                    label: props.name,
                  })
                }}
                responsive={true}
                autoplay={true}
                controls
                src={stream}
              ></Stream>
            )}
          </div>
        </div>
      )}
      {init && login && purchased && !qa && props.qa && (
        <div>
          <div
            style={{
              color: "#fff",
              margin: "0 auto",
              padding: "0 1rem",
              textAlign: "justify",
              maxWidth: "720px",
              width: "100%",
              boxSizing: "border-box",
            }}
          >
            <h3>身份驗證</h3>
            <div>
              很抱歉，看起來你目前沒有購買 IxDTW 2.0 互動設計年會 票券。
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                margin: "0.5rem 0 3rem",
              }}
            >
              <a
                class="cta"
                target="_blank"
                rel="noreferrer"
                href="https://tickets.ixda.org.tw/events/27"
              >
                馬上購買
              </a>
            </div>
          </div>
        </div>
      )}
      {init && login && purchased && qa && props.qa && (
        <div style={{ paddingTop: "56.25%", position: "relative" }}>
          <div
            style={{
              position: "absolute",
              inset: 0,
              height: "100%",
              width: "100%",
              top: 0,
            }}
          >
            <div
              className={style.loader}
              style={{ display: loading ? "block" : "none" }}
            >
              <div className={style.shadow}></div>
              <div className={style.box}></div>
            </div>
            {stream && (
              <Stream
                onCanPlay={() => {
                  setLoading(false)
                  trackCustomEvent({
                    category: "video",
                    action: "play",
                    label: props.name,
                  })
                }}
                autoplay
                responsive={true}
                autoplay={true}
                controls
                src={stream}
              ></Stream>
            )}
          </div>
        </div>
      )}
      <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
        <Dialog.Overlay className={style.overlay} />

        <Dialog.Title>哎呀</Dialog.Title>
        <Dialog.Description>{message}</Dialog.Description>
        <div className={style.dialogContainer}>
          <div className={style.dialog}>
            <p>{message}</p>
            <button onClick={() => setIsOpen(false)}>關閉</button>
          </div>
        </div>
      </Dialog>
    </>
  )
}

export default Video
